import axios from "axios";

export default function SupervisoryUnitService() {

  return axios.get(process.env.REACT_APP_API_HOST + "/report/supervisory_unit", {
    responseType: 'blob',
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
};
